import { render, staticRenderFns } from "./ApiWhatsapp.vue?vue&type=template&id=1d35ccca&"
import script from "./ApiWhatsapp.vue?vue&type=script&lang=js&"
export * from "./ApiWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports